var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThuThuat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00612 8.52082L9.13551 10.9984C9.49333 11.2053 9.83046 11.4462 10.1422 11.7176L13.3055 14.8808C13.3433 14.9186 13.3881 14.9486 13.4375 14.969C13.4868 14.9895 13.5397 15 13.5932 15C13.6466 15 13.6995 14.9895 13.7489 14.969C13.7982 14.9486 13.8431 14.9186 13.8808 14.8808C13.9186 14.8431 13.9486 14.7982 13.969 14.7489C13.9895 14.6995 14 14.6466 14 14.5932C14 14.5397 13.9895 14.4868 13.969 14.4375C13.9486 14.3881 13.9186 14.3433 13.8808 14.3055L10.7176 11.1422C10.4357 10.8389 10.194 10.5005 9.99837 10.1355L7.52082 6.00612M7.23061 6L5 8.23061",
    stroke: "#6576FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52582 5.47365C9.16529 4.83419 9.16529 3.79741 8.52582 3.15794C7.88635 2.51847 6.84957 2.51847 6.2101 3.15794C5.57064 3.79741 5.57064 4.83419 6.2101 5.47365C6.84957 6.11312 7.88635 6.11312 8.52582 5.47365Z",
    stroke: "#6576FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47357 9.52627C5.11304 8.8868 5.11304 7.85002 4.47357 7.21055C3.83411 6.57108 2.79733 6.57108 2.15786 7.21055C1.51839 7.85002 1.51839 8.8868 2.15786 9.52627C2.79733 10.1657 3.83411 10.1657 4.47357 9.52627Z",
    stroke: "#6576FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThuThuat);
export default __webpack_public_path__ + "static/media/ThuThuat.52567736.svg";
export { ForwardRef as ReactComponent };